<template>
  <div v-loading.body="loading">
    <div
      v-if="resData"
      class="row"
      :gutter="20"
      type="flex"
      align="middle"
      justify="start"
    >
      <div
        v-for="item in storehouseIds"
        v-if="item.key !== -1"
        :key="item.key"
        class="status"
        :class="{ active: origin === item.key }"
        @click="selectOrigin(item.key)"
      >
        {{ item.label }}
      </div>
    </div>
    <el-row class="filter">
      <el-col>
        <div
          style="
            background: #f3f3f3;
            height: 30px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>查询搜索</div>
          <el-button
            type="text"
            style="margin-left: auto"
            :icon="filterFold ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
            @click="toggleFilter"
            >{{ filterFold ? "展开筛选" : "收起筛选" }}</el-button
          >
        </div>
        <el-collapse-transition>
          <div v-show="!filterFold">
            <div style="padding: 10px 25px">
              <el-form :inline="true" :model="form" class="demo-form-inline">
                <el-form-item>
                  <el-select
                    v-model="search_type"
                    placeholder=""
                    style="width: 150px"
                  >
                    <el-option
                      v-for="item in search_options"
                      :key="item.key"
                      :label="item.name"
                      :value="item.key"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item style="margin-left: -15px; width: 165px">
                  <el-input
                    v-model="search_value"
                    placeholder="请输入搜索内容"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>

                <el-form-item>
                  <el-input
                    v-model="form.supply_name"
                    placeholder="商家名称"
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-select
                    v-model="form.pgid"
                    placeholder="代采组"
                    filterable
                    style="width: 150px"
                  >
                    <el-option label="全部" value="0"></el-option>
                    <el-option
                      v-for="item in (searchOptions &&
                        searchOptions.optionsPg) ||
                      []"
                      :key="item.key"
                      :label="item.label"
                      :value="item.key"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-select
                    v-model="form.pg_member_id"
                    placeholder="代采员"
                    filterable
                    style="width: 150px"
                  >
                    <el-option label="全部" value="0"></el-option>
                    <el-option
                      v-for="item in (searchOptions &&
                        searchOptions.optionsPgM) ||
                      []"
                      :key="item.key"
                      :label="item.label"
                      :value="item.key"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-select
                    v-model="form.pg_id"
                    placeholder="买手组"
                    filterable
                    style="width: 150px"
                  >
                    <el-option label="全部" value="0"></el-option>
                    <el-option
                      v-for="item in (searchOptions &&
                        searchOptions.optionsMs) ||
                      []"
                      :key="item.key"
                      :label="item.label"
                      :value="item.key"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-select
                    v-model="form.stock_source"
                    placeholder="入库来源"
                    filterable
                    style="width: 150px"
                  >
                    <el-option label="全部" value="0"></el-option>
                    <el-option
                      v-for="item in (searchOptions &&
                        searchOptions.stockSource) ||
                      []"
                      :key="item.key"
                      :label="item.label"
                      :value="item.key"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-select
                    v-model="form.status"
                    placeholder="是否异常"
                    style="width: 150px"
                  >
                    <el-option label="全部" value="0"></el-option>
                    <el-option
                      v-for="item in (searchOptions &&
                        searchOptions.optionsStatus) ||
                      []"
                      :key="item.key"
                      :label="item.label"
                      :value="item.key"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-select
                    v-model="form.type"
                    placeholder="分播类型"
                    style="width: 150px"
                  >
                    <el-option label="全部" value="0"></el-option>
                    <el-option
                      v-for="item in (searchOptions &&
                        searchOptions.optionsCutType) ||
                      []"
                      :key="item.key"
                      :label="item.label"
                      :value="item.key"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-select
                    v-model="form.source"
                    placeholder="分播来源"
                    style="width: 150px"
                  >
                    <el-option label="全部" value="0"></el-option>
                    <el-option
                      v-for="item in (searchOptions &&
                        searchOptions.optionsSource) ||
                      []"
                      :key="item.key"
                      :label="item.label"
                      :value="item.key"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-select
                    v-model="form.wave_type"
                    placeholder="拣货类型"
                    style="width: 150px"
                  >
                    <el-option label="全部" value="0"></el-option>
                    <el-option
                      v-for="item in (searchOptions &&
                        searchOptions.optionsWaveType) ||
                      []"
                      :key="item.key"
                      :label="item.label"
                      :value="item.key"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-select
                    v-model="form.assignment_type"
                    placeholder="拣货方式"
                    style="width: 150px"
                  >
                    <el-option label="全部" value="0"></el-option>
                    <el-option
                      v-for="item in (searchOptions &&
                        searchOptions.optionsPickingType) ||
                      []"
                      :key="item.key"
                      :label="item.label"
                      :value="item.key"
                    ></el-option>
                  </el-select>
                </el-form-item>

                <el-form-item label="分播时间：">
                  <el-date-picker
                    v-model="form.create_time"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    :default-time="['06:00:00', '06:00:00']"
                  >
                  </el-date-picker>
                </el-form-item>

                <el-form-item>
                  <el-button type="" @click="reset">重置</el-button>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="search">查询</el-button>
                </el-form-item>
                <el-form-item>
                  <el-button type="success" @click="exportExcel">
                    导出
                  </el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </el-collapse-transition>
      </el-col>
    </el-row>
    <el-row>
      <el-col style="border: 1px solid #ddd">
        <div style="margin-bottom: 0">
          <el-table
            v-if="resData"
            ref="multipleTable"
            v-loading="tableLoading"
            height="800"
            :data="resData.list"
            tooltip-effect="dark"
            style="width: 100%"
            @selection-change="handleSelectionChange"
          >
            <el-table-column
              align="right"
              type="selection"
              width="55"
            ></el-table-column>
            <el-table-column align="center" label="图片">
              <template slot-scope="scope">
                <div
                  v-if="scope.row.imgs.length > 0"
                  style="width: 70px; height: 70px"
                >
                  <img
                    :src="scope.row.imgs[0]"
                    style="width: 100%; height: 100%"
                    @click="showImages(scope.row.imgs)"
                  />
                </div>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              show-overflow-tooltip
              prop="goods_name"
              label="商品名称"
              width="150"
            ></el-table-column>
            <el-table-column
              align="center"
              show-overflow-tooltip
              prop="dbid"
              label="打标id"
              width="150"
            ></el-table-column>
            <el-table-column align="center" label="货号/颜色/尺码">
              <template slot-scope="scope">
                {{ scope.row.goods_no }}/ {{ scope.row.co_val }}/
                {{ scope.row.si_val }}
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop="sku"
              label="sku编号"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="goods_kh"
              label="款号"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="weight"
              label="商品重量"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="supply_name"
              label="商家"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="market_name"
              label="市场"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="pgname"
              label="代采组"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="pgm_name"
              label="代采员"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="pg_name"
              label="买手组"
            ></el-table-column>
            <!--                        <el-table-column align="center" prop="rk" label="入库来源"></el-table-column>-->
            <el-table-column
              align="center"
              prop="stock_in_record_stock_source"
              label="入库来源"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="device_cut_log_status"
              label="是否异常"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="summary_no"
              label="汇总单"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="wave_picking_no"
              label="波次单"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="picking_assignment_no"
              label="拣货单"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="picking_assignment_wave_type"
              label="拣货类型"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="picking_assignment_assignment_type"
              label="拣货方式"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="grid_no"
              label="格口号"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="admin_name"
              label="分播人"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="create_time"
              label="分播时间"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="device_cut_log_type"
              label="分播类型"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="device_cut_log_source"
              label="分播来源"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="device_scan_admin"
              label="设备分播扫描人"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="exception_reason"
              label="异常原因"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="content"
              label="返回内容"
            ></el-table-column>
          </el-table>
        </div>
        <div v-if="resData" style="text-align: right; padding: 25px">
          <el-pagination
            :current-page.sync="curPage"
            background
            layout="total, prev, pager, next, jumper ,sizes"
            :total="resData.count"
            :page-size="form.pagesize"
            :page-sizes="[50, 100, 200, 500, 1000]"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
          >
          </el-pagination>
        </div>
      </el-col>
    </el-row>
    <preview-image
      :imgs="images"
      :show="showbox"
      @closeBox="closeBox()"
    ></preview-image>
  </div>
</template>

<script>
import PreviewImage from "../../components/PreviewImage.vue";
import apiBaseURL from "@/utils/baseUrl.js";

export default {
  components: {
    PreviewImage,
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fetchCondition();
    });
  },
  data() {
    return {
      images: [],
      showbox: false,
      fileList: [],
      resData: {},
      form: {
        pagesize: 50,
        create_time: this.$excalibur.getDateTimeOnHours(-2, 6),
      },
      search_type: "dbid",
      search_options: [
        { key: "dbid", name: "打标id" },
        { key: "goods_no", name: "货号" },
        { key: "goods_kh", name: "款号" },
        { key: "sku", name: "sku编号" },
        { key: "create_admin", name: "分播人" },
        { key: "type_no", name: "波次单" },
        { key: "type_summary_no", name: "汇总单" },
      ],
      search_value: "",
      origin_list: [
        {
          origin_id: 1,
          origin_name: "广州",
        },
        {
          origin_id: 2,
          origin_name: "杭州",
        },
      ],
      storehouseIds: [],
      origin: 1,
      space: "",
      ss_id: 0,
      loading: false,
      tableLoading: false,
      url: "/erp/DeviceCut/cutLog",
      curPage: 1,
      filterFold: false,
      isAll: false,
      searchOptions: null,
    };
  },
  computed: {
    filteredForm() {
      for (const key in this.form) {
        if (
          this.form[key] === undefined ||
          this.form[key] === "" ||
          this.form[key] === null
        ) {
          delete this.form[key];
        }
      }
      return this.form;
    },
  },
  methods: {
    showImages(img) {
      this.showbox = true;
      this.images = img;
    },
    closeBox() {
      this.showbox = false;
    },
    selectOrigin(origin_id) {
      this.origin = origin_id;
      this.form.origin = origin_id;
      this.fetchData(true);
    },

    exportExcel() {
      this.form.is_excel = 1;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.form.is_excel = 0;
          window.open(apiBaseURL + res.data.data.file);
        }
      });
    },
    fetchCondition() {
      this.$http
        .post("/erp/DeviceCut/getCondition", this.filteredForm)
        .then((res) => {
          this.loading = false;
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            this.searchOptions = res.data.data;
            this.origin = res.data.data.origin;
          }
        });
    },
    fetchData(showLoading) {
      this.$http
        .post("/erp/StockStorehouse/listStockStorehouseConfig")
        .then((res) => {
          if (res.data.code == 200) {
            this.storehouseIds = res.data.data;
          }
        });
      if (showLoading) {
        this.loading = true;
      }
      if (this.search_value != "") {
        for (const key in this.search_options) {
          this.form[this.search_options[key].key] = "";
        }
        this.form[this.search_type] = this.search_value;
      } else {
        for (const key in this.search_options) {
          this.form[this.search_options[key].key] = "";
        }
      }
      this.$http.post(this.url, this.filteredForm).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
          console.log(this.resData);
        }
      });
    },
    toggleFilter() {
      this.filterFold = !this.filterFold;
    },
    handleSelectionChange(val) {
      const multipleSelection = [];
      const claims_detail_id = [];
      for (const key in val) {
        multipleSelection[key] = val[key].work_id;
        if (val[key].claims_detail_id) {
          claims_detail_id[key] = val[key].claims_detail_id;
        }
      }
      this.multipleSelection = multipleSelection;
      this.claims_detail_id = claims_detail_id;
    },
    // 切换页码
    handleCurrentChange(val) {
      this.form.page = val;
      this.tableLoading = true;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        setTimeout(() => {
          this.tableLoading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    handleSizeChange(val) {
      this.form.pagesize = val;
      this.fetchData(true);
    },

    search() {
      this.form.page = 1;
      this.loading = true;
      this.form.is_excel = 0;
      this.fetchData(true);
    },

    trim(str, is_global) {
      let result;
      result = str.replace(/(^\s+)|(\s+$)/g, "");
      if (is_global.toLowerCase() == "g") {
        result = result.replace(/\s/g, "");
      }
      return result;
    },
    reset() {
      this.search_value = "";
      this.form = {};
      this.form.page = 1;
      this.form.pagesize = 50;
    },
  },
};
</script>

<style scoped>
.row {
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 12px;
}

.column {
  text-align: center;
  border: 1rpx solid #ddd;
  font-size: 12px;
}

.data-statics {
  background: #f3f3f3;
  height: 40px;
  font-size: 14px;
  color: #333;
  line-height: 40px;
  padding: 0 25px;
}

.filter {
  border: 1px solid #ddd;
}

.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/devicecut/CutLog.vue